import { AquariusButton } from "@smartrr/shared/customerPortal/components/AquariusButton";
import { AquariusButtonGroup } from "@smartrr/shared/customerPortal/components/AquariusButtonGroup";
import { PurchaseStateAndDelivery } from "@smartrr/shared/entities/PurchaseState";
import { ISmartrrSellingPlan } from "@smartrr/shared/entities/SellingPlanGroup";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

import { ValidViews } from "../../../OrderOptionsModalInner";
import { useFormattedCustomerSupportEmail } from "../../hooks/useFormattedCustomerSupportEmail";

export const HandleReselectingSellingPlan = ({
  sellingPlanOptions,
  delivery,
  setView,
}: {
  sellingPlanOptions: ISmartrrSellingPlan[];
  delivery: PurchaseStateAndDelivery;
  setView: React.Dispatch<React.SetStateAction<ValidViews>>;
}) => {
  const purchaseState = delivery.purchaseState;
  const formattedCustomerSupportEmail = useFormattedCustomerSupportEmail(purchaseState);

  return (
    <React.Fragment>
      {sellingPlanOptions.length ? (
        <AquariusButtonGroup topBorder>
          <AquariusButton sx={{ marginTop: 0 }} href={formattedCustomerSupportEmail}>
            {typedLocalize(`general.contactSupportBtn`)}
          </AquariusButton>
          <AquariusButton filled onClick={() => setView("Swap Plan")}>
            {typedLocalize(`subscriptions.yourSubscriptions.orderOptionsModal.changePlanBtn`)}
          </AquariusButton>
        </AquariusButtonGroup>
      ) : (
        <AquariusButton sx={{ marginTop: "15px" }} href={formattedCustomerSupportEmail}>
          {typedLocalize(`general.contactSupportBtn`)}
        </AquariusButton>
      )}
    </React.Fragment>
  );
};
